export default __webpack_public_path__ + "static/media/user-avatar.08907022.svg";